import React from 'react';
const links = ['Terms of Service', 'Privacy Policy', 'Refund Policy', 'Contact'];
export function Footer() {
  return <footer className="w-full bg-ink px-5 py-12" data-id="element-90" data-mp="3gg10u7y865zr">
      <div className="mx-auto max-w-5xl text-center" data-id="element-91" data-mp="32nulgo2wc31d">
        <p className="font-display text-3xl font-extrabold uppercase leading-none text-white" data-id="element-92" data-mp="32p5qer82vgu2">
          Football Ready<span className="align-super text-xs" data-id="element-93" data-mp="36ppk1ktg02bg">™</span>
        </p>
        <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.24em] text-lime" data-id="element-94" data-mp="3ues8bbil0tex">
          Plan Less. Coach More. Win Their Hearts.
        </p>
        <nav aria-label="Footer" data-id="element-95" data-mp="36d3cxfoatnb">
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-white/55" data-id="element-96" data-mp="3levi35gjnmhr">
            {links.map(link => <li key={link} data-id="element-97" data-mp="3qf9qiom24ygb">
                <a href="#offer" className="transition-colors hover:text-lime" data-id="element-98" data-mp="29ynlrlrph7ej">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-white/35" data-id="element-99" data-mp="3l9adtjp9964y">
          © 2026 Football Ready. All rights reserved.
        </p>
      </div>
    </footer>;
}